import { t as throttle } from './index2.js';
import 'tty';
import 'os';
import 'deepmerge';
import 'axios';
import 'vue';
import { n as normalizeComponent } from './normalize-component.js';

//
var script = {
  props: {
    value: {
      type: Number,
      required: true
    },
    isMediaProgressSlider: {
      type: Boolean,
      default: false
    },
    isPlaying: {
      type: Boolean
    },
    isReady: {
      type: Boolean
    },
    pinSize: {
      type: Number,
      default: 15
    },
    trackSize: {
      type: Number,
      default: 15
    },
    orientation: {
      type: String,
      default: 'horizontal',
      validator: function validator(v) {
        return ['horizontal', 'vertical'].includes(v);
      }
    },
    length: {
      type: Number
    },
    seekable: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      track: null,
      progress: null,
      pin: null,
      mouseDown: false,
      touchStartTime: 0,
      isSliderTap: false
    };
  },
  mounted: function mounted() {
    this.onTouchStart = throttle(this.onTouchStart, 200);
    this.onTouchMove = throttle(this.onTouchMove, 50);
    this.onTouchEnd = throttle(this.onTouchEnd, 200);
    this.track = this.$el.querySelector('.js-track');
    this.progress = this.$el.querySelector('.js-progress');
    this.pin = this.$el.querySelector('.js-pin');

    if (this.isMediaProgressSlider) {
      this.$el.classList.add('c-slider--media-progress-slider');
    } else {
      this.pin.style.height = this.pinSize + 'px';
      this.pin.style.width = this.pinSize + 'px';
    } // this.track.addEventListener('click', this.onTrackClick, true)


    if (this.orientation === 'horizontal') {
      this.$el.classList.add('c-slider--horizontal');
      this.track.style.height = this.trackSize + 'px';
      this.progress.style.height = this.trackSize + 'px';
      var length = this.length ? this.length + 'px' : '100%';
      this.$el.style.width = length;
      this.$el.style.height = this.pinSize + 'px';
    } else {
      this.$el.classList.add('c-slider--vertical');
      this.track.style.width = this.trackSize + 'px';
      this.progress.style.width = this.trackSize + 'px';

      var _length = this.length ? this.length + 'px' : '100%'; // this.progress.style.length = length


      this.$el.style.height = _length;
      this.$el.style.width = this.pinSize + 'px';
    }
  },
  beforeDestroy: function beforeDestroy() {// this.track.removeEventListener('click', this.onTrackClick)
  },
  methods: {
    onTouchStart: function onTouchStart(e) {
      e.preventDefault(); // To prevent the whole page scrolling on iPhone

      if (e.type === 'mousedown') this.mouseDown = true;
      var path = e.path || e.composedPath && e.composedPath();

      if (path.includes(this.pin)) {
        this.tapStartOffset = this.getEventOffset(e);
        this.isPinTap = true;
      } else {
        if (this.seekable) {
          this.isSliderTap = true;
          this.updateValue(this.getEventOffset(e));
          if (!this.isPlaying) this.$emit('pinTap');
        }
      }

      this.touchStartTime = Date.now();
      e.stopPropagation();
      this.$xp.navigation.showNav(true);
    },
    onTouchMove: function onTouchMove(e) {
      e.preventDefault(); // To prevent the whole page scrolling on iPhone

      if (this.mouseDown || e.type === 'touchmove') {
        if (this.isPinTap || this.isSliderTap) {
          var currentOffset = this.getEventOffset(e); // accept tolerance value of 10

          if (Math.abs(currentOffset - this.tapStartOffset) > 500) {
            this.isPinTap = false;
            console.log('onTouchMove() STOP isPinTap', e.type, e);
          } else {
            this.tapStartOffset = currentOffset;

            if (this.seekable) {
              this.updateValue(this.getEventOffset(e));
            }
          }
        }
      }

      e.stopPropagation();
      this.$xp.navigation.showNav(true);
    },
    onTouchEnd: function onTouchEnd(e) {
      if (e.type === 'mouseup') this.mouseDown = false;

      if (this.isPinTap) {
        var wasSeeking = Date.now() - this.touchStartTime > 400;
        console.log('wasSeeking:', wasSeeking, ', touchTime:', Date.now() - this.touchStartTime);

        if (!wasSeeking || !this.isPlaying) {
          console.log('pin tap');
          this.$emit('pinTap');
        }
      }

      this.isPinTap = false;
      this.isSliderTap = false;
      e.stopPropagation();
    },
    getEventOffset: function getEventOffset(e) {
      var offset;

      if (e.touches) {
        offset = this.getTouchOffset(e);
      } else {
        offset = this.getMouseOffset(e);
      }

      return offset;
    },
    getTouchOffset: function getTouchOffset(e) {
      var boundingRect = this.$el.getBoundingClientRect();

      if (this.orientation === 'horizontal') {
        return e.touches[0].clientX - boundingRect.left;
      } else {
        // console.log(`getTouchOffset: ${boundingRect.height} - ${e.touches[0].clientY} + ${boundingRect.top} = ${boundingRect.height - e.touches[0].clientY + boundingRect.top}`)
        return boundingRect.height - e.touches[0].clientY + boundingRect.top;
      }
    },
    getMouseOffset: function getMouseOffset(e) {
      var boundingRect = this.$el.getBoundingClientRect();

      if (this.orientation === 'horizontal') {
        return e.clientX - boundingRect.left;
      } else {
        return boundingRect.height - (e.clientY - boundingRect.top);
      }
    },
    updateValue: function updateValue(offset) {
      var value = offset / this.getTrackLength(); // console.log(`onTouchMove value: ${offset} / ${this.getTrackLength()} = ${value}`)

      if (value < 0) {
        this.$emit('update:value', 0);
      } else if (value >= 0 && value <= 1) {
        this.$emit('update:value', value);
      } else if (value > 1) {
        this.$emit('update:value', 1);
      }
    },
    getTrackLength: function getTrackLength() {
      if (this.track) {
        if (this.orientation === 'horizontal') {
          return this.track.clientWidth;
        } else {
          return this.track.clientHeight;
        }
      }

      return 0;
    }
  },
  computed: {
    progressStyle: function progressStyle() {
      if (this.orientation === 'horizontal') {
        return {
          width: this.getTrackLength() * this.value + 'px'
        };
      } else {
        return {
          height: this.getTrackLength() * this.value + 'px'
        };
      }
    },
    pinStyle: function pinStyle() {
      if (this.orientation === 'horizontal') {
        return {
          left: this.getTrackLength() * this.value + 'px'
        };
      } else {
        return {
          bottom: this.getTrackLength() * this.value + 'px'
        };
      }
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "c-slider",
      on: {
        touchstart: _vm.onTouchStart,
        mousedown: _vm.onTouchStart,
        touchmove: _vm.onTouchMove,
        mousemove: _vm.onTouchMove,
        touchend: _vm.onTouchEnd,
        mouseup: _vm.onTouchEnd
      }
    },
    [
      _c("div", { staticClass: "c-slider__track js-track" }, [
        _c("div", {
          staticClass: "c-slider__progress js-progress",
          style: _vm.progressStyle
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "c-slider__pin js-pin",
            style: _vm.pinStyle,
            attrs: { role: "button", tabindex: "0", "aria-label": "Play/Pause" }
          },
          [
            _vm.isMediaProgressSlider && !_vm.isReady
              ? _c("span", {
                  staticClass: "xp xp-spinner is-spinning xp--large",
                  attrs: { "aria-hidden": "true" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isMediaProgressSlider && _vm.isReady && !_vm.isPlaying
              ? _c("span", {
                  staticClass: "xp xp-play xp--large",
                  attrs: { "aria-hidden": "true" }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isMediaProgressSlider && _vm.isReady && _vm.isPlaying
              ? _c("span", {
                  staticClass: "xp xp-pause xp--large",
                  attrs: { "aria-hidden": "true" }
                })
              : _vm._e()
          ]
        )
      ])
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
//# sourceMappingURL=Slider.js.map
